'use strict';

Object.defineProperty(exports, "__esModule", {
				value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
				(function (MobileImageCheck, $) {
								var $dom = {};

								var cacheDom = function cacheDom() {
												$dom.MobileImageCheck = $('[data-mobile-image-check]');
								};

								var MobileImage = function MobileImage(currentBg) {
												var mobileSrc = currentBg.attr('data-mobile-image');
												var desktopSrc = currentBg.attr('data-desktop-image');
												if (desktopSrc.indexOf("https:") === -1) {
																desktopSrc = 'https:' + desktopSrc;
												}
												if (mobileSrc.indexOf("https:") === -1) {
																mobileSrc = 'https:' + mobileSrc;
												}
												if ($(window).width() < 768) {
																if (currentBg.css('background-image') != 'url(' + mobileSrc + ')' && mobileSrc != 'https:') {
																				currentBg.css('background-image', 'url(' + mobileSrc + ')');
																}
												} else {
																if (currentBg.css('background-image') != 'url(' + desktopSrc + ')') {
																				currentBg.css('background-image', 'url(' + desktopSrc + ')');
																}
												}
								};

								MobileImageCheck.init = function () {
												cacheDom();
												$dom.MobileImageCheck.each(function () {
																var currentBg = $(this);
																MobileImage(currentBg);
																$(window).on('resize', function () {
																				MobileImage(currentBg);
																});
												});
								};
				})(window.MobileImageCheck = window.MobileImageCheck || {}, _jquery2.default, undefined);
};